module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form fxt-footer"
  }, [_c('h3', {
    staticClass: "fw-bold f-700 mb-3"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("registerSuccess.title")) + "\n                ")]), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(_vm.$t("registerSuccess.message")) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "medium": "",
      "color": "primary"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v(_vm._s(_vm.$t("allPage.homepage")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c69115e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/RegisterSuccess.vue
// module id = 433
// module chunks = 0